import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    whatILike: en,
  },
  fr: {
    whatILike: fr,
  },
  pt: {
    whatILike: pt,
  },
};
